






















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class DisclaimerModal extends Vue {
  private showModal = false;

  public mounted() {
    this.$store.getters["ui/hasAcceptedLinkDisclaimer"] ? (this.showModal = false) : (this.showModal = true);
  }

  private acceptTerms() {
    this.$store.dispatch("ui/setHasAcceptedLinkDisclaimer", true);
    this.showModal = false;
  }
}
